
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import GlassBox from "./GlassBox";
import {
  DashboardImg,
  DashboardImage1,
  DashboardImage2,
  DashboardImage3,
  DashboardImage4,
} from "../../constant";
import DashboardIcon from '@mui/icons-material/Dashboard';
import Dock from "../Home/IconCarousal";
import { useState } from "react";
import { avalancheFeatures } from "../../helper";

const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  flexDirection: "column",
  padding: "60px 24px",
  position: "relative",
  overflow: "hidden",
  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    left: "45%",
    top: "50%",
    bottom: "10%",
    transform: "translateX(-100%) translateY(-50%)",
    background: "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
    backdropFilter: 'blur(500px)',
    zIndex: 0,
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(3, 1),
  }
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%", // Set to 95% width
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const IconsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  gap: theme.spacing(4),
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(8),
  flexWrap: "wrap",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(3),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(1),
    justifyContent: "space-evenly",
  }
}));

export default function AchieveOutcome({ title, subTitle }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const features = avalancheFeatures[selectedIndex];

  return (
    <MainContainer>
      <ContentContainer>
        <Box sx={{
          width: "95%",
          textAlign: "center",
          py: 4,
        }}>
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "24px", sm: "32px", md: "40px" },
              fontWeight: 700,
              mb: 4,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: "#8C8CC2",
              fontSize: { xs: "16px", md: "18px" },
              lineHeight: 1.8,
            }}
          >
            {subTitle}
          </Typography>
        </Box>

        <IconsContainer>
          <Dock
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
          />
        </IconsContainer>

        <GlassBox
          title={features?.cardTitle}
          subtitle={features?.cardSubtitle}
          features={features?.slideSection}
          index={selectedIndex}
        />
      </ContentContainer>
    </MainContainer>
  );
}